module.exports = __webpack_public_path__ + "static/media/foooter_code1.fe6249c1.png";